module.exports = __webpack_public_path__ + "static/img/what_need1.4ccf2d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/what_need1.png
// module id = MXJm
// module chunks = 0